import { IStats } from '../../planner-interfaces';

interface IStatsProps {
    stats: IStats;
}

const Stats = ({ stats }: IStatsProps) => {
    return (
        <>
            {
                stats &&
                <div className="text-sm my-2 text-slate-200">
                    <div className="text-slate-400 pb-3 pt-3">Stats</div>

                    <a className="block" href="/planner/filters/2"><span className="text-[#d2ef98] underline">root without nested</span>: { stats.rootWithoutNested }</a>
                    <a className="block mb-2" href="/planner/filters/3"><span className="text-[#d2ef98] underline">root with nested no-dates</span>: { stats.nestedNoDateCount }</a>


                    <a className="block" href="/planner/filters/1"><span className="text-[#61c88b] underline">root</span>: { stats.rootCount }</a>
                    <div><span className="text-[#61c88b]">root completed</span>: { stats.rootCountCompleted }</div>
                    <div className="mb-2"><span className="text-[#61c88b]">root non-completed</span>: { stats.rootCount - stats.rootCountCompleted }</div>

                    <div><span className="text-[#a689e2]">total</span>: { stats.total }</div>
                    <div><span className="text-[#a689e2]">completed</span>: { stats.completed }</div>
                    <div className="mb-2"><span className="text-[#a689e2]">non-completed</span>: { stats.total - stats.completed }</div>

                </div>
            }
        </>
    )
};

export default Stats;